import { Controller } from '../utils/controller';

interface ICart {
  itemsCount: number;
  subtotal: string;
  items: {
    title: string;
    subtitle: string;
    quantity: number;
    image: string;
    price: number;
    formattedAppliedPrice: string;
    url: string;
    isRewardItem: number;
    rewardPointsPriceFormatted: number;
  }[];
}

export default class extends Controller {
  static targets = [
    'displayToggle',
    'buttonIcon',
    'overlay',
    'cartItems',
    'subtotal',
    'itemsCount',
    'cartButton',
    'closeButton'
  ];
  static requiredTargets = [];

  static classes = ['hidden'];
  static requiredClasses = [];

  static values = {
    loyaltyLabel: {
      default: '',
      type: String
    },
    loyaltyPointsLabel: {
      default: '',
      type: String
    }
  };

  // TARGETS
  declare cartButtonTarget: HTMLDivElement | HTMLButtonElement;
  declare cartItemsTarget: HTMLDivElement;
  declare closeButtonTarget: HTMLDivElement | HTMLButtonElement;
  declare itemsCountTargets: HTMLDivElement[];
  declare overlayTarget: HTMLDivElement;
  declare readonly hasCartButtonTarget: boolean;
  declare readonly hasCartItemsTarget: boolean;
  declare readonly hasCloseButtonTarget: boolean;
  declare readonly hasItemsCountTarget: boolean;
  declare readonly hasOverlayTarget: boolean;
  declare readonly hasSubtotalTarget: boolean;
  declare subtotalTarget: HTMLDivElement;

  // CLASSES
  declare hiddenClass: string;

  //VALUES
  declare loyaltyLabelValue: string;
  declare loyaltyPointsLabelValue: string;

  handleCartUpdated(event) {
    this.update(event.detail);
    this.hasOverlayTarget && this.toggleOverlay();
  }

  handleReactCartUpdated(event) {
    if (event?.detail?.itemQty) {
      this.itemsCountTargets.forEach((itemsCountTarget) => {
        itemsCountTarget.innerHTML = event.detail.itemQty;
      });
    }
  }

  update(data: ICart) {
    const html = data.items.map(
      (item) => `
      <section class="flex py-4 border-b items-end">
        <a href="${item.isRewardItem ? '#' : item.url}" class="flex block mr-2">
          <img class="max-w-[85px]" src="${item.image}">
        
          <div class="flex-auto text-left">
            <p class="font-headline font-bold uppercase">${item.title}</p>
            <span class="block">${item.subtitle !== null ? item.subtitle : ''}</span>
            <span class="block">${
              item.isRewardItem
                ? item.rewardPointsPriceFormatted + ' points'
                : item.formattedAppliedPrice
            }</span>
            <span class="block text-primary-300">${
              item.isRewardItem
                ? this.loyaltyLabelValue
                : Math.ceil(item.price) * 10 + this.loyaltyPointsLabelValue
            }</span>
            <span class="block">QTY: <span>${item.quantity}</span>
            </span>
          </div>
        </a>
       
      </section>
    `
    );

    if (this.hasCartItemsTarget) {
      this.cartItemsTarget.innerHTML = html.join('');
    }
    if (this.hasSubtotalTarget) {
      this.subtotalTarget.innerHTML = data.subtotal;
    }
    if (this.hasItemsCountTarget) {
      this.itemsCountTargets.forEach((itemsCountTarget) => {
        const hideCount = itemsCountTarget.classList.contains('empty:hidden') && !data.itemsCount;
        const itemsCount = (data.itemsCount || 0).toString();
        itemsCountTarget.innerHTML = hideCount ? '' : itemsCount;
      });
    }
  }

  toggleOverlay() {
    this.hasOverlayTarget && this.overlayTarget.classList.toggle(this.hiddenClass);
  }
}
